import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal } from "@mui/material";
import useTranslation from "../hooks/traslation";

interface IndustryDetailsModalProps {
  name: string;
  open: boolean;
  selectedId: string;
  onClose: () => void;
  nameAr: string;
}

export default function IndustryDetails({
  open,
  name,
  selectedId,
  onClose,
  nameAr,
}: IndustryDetailsModalProps) {
  const isViewMode = Boolean(selectedId);
  const translate = useTranslation();

  return (
    <Modal className="modal addCategory_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Industry Details</h2>
            <div className="btn-close" onClick={onClose}>
              <CloseIcon />
            </div>
          </div>

          <form className="form" action="">
            <div className="control_group">
              <label>Industry Name {translate?.main?.english || "English"}</label>
              <TextField
                placeholder="Industry Name"
                fullWidth
                value={name}
                hiddenLabel
                disabled={isViewMode}
              />
            </div>
            <div className="control_group">
              <label>Industry Name {translate?.main?.arabic || "Arabic"}</label>
              <TextField
                placeholder="Industry Name Arabic"
                fullWidth
                value={nameAr}
                hiddenLabel
                disabled={isViewMode}
              />
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
